// extracted by mini-css-extract-plugin
export var fallback = "_8-0";
export var icon = "_8-1";